import { Widget, WidgetHeader } from './shared';
import t from '../../../util/translation/translation';
import { Link } from 'react-router-dom';
import ScheduledMessages from '../../../shared/components/messageList/ScheduledMessages';

const SchedueldMessages = () => {
  return (
    <Widget>
      <WidgetHeader
        bottomSpace="sm"
        title={t('ScheduledMessagesPage.scheduledMessages')}
        subhead={''}
      >
        <Link to="/messages?tab=2" className="events-link">
          {t('DashboardPage.viewAll')}
        </Link>
      </WidgetHeader>
      <ScheduledMessages />
    </Widget>
  );
};

export default SchedueldMessages;
